import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalAppService} from '../../../../core/commons/global-app.service';
import {FormViewService} from '../../../services/form-view.service';
import {AbstractControl, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {defaultValueValidator} from '../../form-view-detail/form-view-detail.component';
import {FormViewData} from '../../../domain/form-view-data';
import {FormViewField} from '../../../domain/form-view-field';
import {FormView} from '../../../domain/form-view';
import {SaveViewDialogComponent} from '../save-view-dialog/save-view-dialog.component';
import {MatDialog} from '@angular/material';
import {FormViewFieldData} from '../../../domain/form-view-field-data';
import {MessageSeverity} from '../../../../core/commons/message-severity';
import {Observable} from 'rxjs/Observable';
import {Paragraph, TextElement, ViewModelText} from "../../view-field/view-field.component";


@Component({
    selector: 'app-form-view-data-editor',
    templateUrl: './form-view-data-editor.component.html',
    styleUrls: ['./form-view-data-editor.component.scss'],
    providers: [FormViewService]
})
export class FormViewDataEditorComponent implements OnInit {
     formGroup: FormGroup;
     viewData: FormViewData;
     viewForm: FormView;
     saveDisabled = true;
     document: ViewModelText = new ViewModelText();

    constructor(private route: ActivatedRoute,
                private router: Router,
                private appService: GlobalAppService,
                private viewService: FormViewService,
                private cd: ChangeDetectorRef,
                private fb: FormBuilder,
                public dialog: MatDialog) {
    }

    ngOnInit() {
        this.route.params
            .map(params => params['id'])
            .switchMap(id => this.viewService.getViewData(id, false))
            .switchMap(viewData => {
                this.viewData = viewData;
                return this.viewService.get(this.viewData.view.id);
            })
            .subscribe(viewForm => {
                this.viewForm = viewForm;
                this.buildFormGroup();
            });
    }

    buildFormGroup() {
        this.formGroup = new FormGroup({});
        this.formGroup.addControl('name', new FormControl(this.viewData.name));

        let p = new Paragraph(this.document);
        p.blockAlignment = this.viewForm.fields[0].blockAlignment;
        p.alignment = this.viewForm.fields[0].alignment;
        p.blockWidth = this.viewForm.fields[0].blockWidth;
        p.indentate = this.viewForm.fields[0].indentate;
        let shouldIndentate = false;
        for (const f of this.viewForm.fields) {
            f.placeholder.split('<br>').forEach(section => {
                section.replace('{@}', '||{@}||')
                    .split('||')
                    .forEach(s => {
                        if (s.trim().length > 0) {
                            if (s === '{@}') {
                                const validators = f.getValidators();
                                validators.push(defaultValueValidator('campo a completar'));
                                const fieldData = this.viewData.findFieldData(f.id);
                                const value = fieldData != null ? fieldData.value : 'campo a completar';
                                const formControl = new FormControl(value, validators);
                                this.formGroup.addControl(f.id.toString(), formControl);
                                const element = new TextElement(ViewModelText.getNewId(), value, p, f.required, true);
                                element.control = formControl;

                                p.values.push(element)

                            } else {
                                p.values.push(new TextElement(ViewModelText.getNewId(), s, p, false, false))
                            }
                        }
                    });
                p.indentate = p.indentate || shouldIndentate || f.indentate;
                if (f.linebreak) {
                    p.blockWidth = f.blockWidth;
                    p.blockAlignment = f.blockAlignment;
                    p.alignment = f.alignment;
                    if (p.values.length)
                        this.document.paragraphs.push(p);
                    p = new Paragraph(this.document);

                }
            });
            if((shouldIndentate || f.indentate) && !f.linebreak){
                shouldIndentate = true;
            } else {
                shouldIndentate = false;
            }
        }

        for (let i = 0; i < this.document.paragraphs.length; i++) {
            const p = this.document.paragraphs[i];
            for (let j = 0; j < p.values.length; j++) {
                let textElement = p.values[j];
                if (textElement.isInput && textElement.value.includes('<br>')) {
                    let split = textElement.value.split('<br>');
                    textElement.value = split.shift();
                    split.forEach(value => {
                        const indexOfParent = textElement.parent.parent.paragraphs.indexOf(textElement.parent);
                        const p = new Paragraph(textElement.parent.parent);
                        p.indentate = textElement.parent.indentate;
                        p.blockWidth = textElement.parent.blockWidth;
                        p.blockAlignment = textElement.parent.blockAlignment;
                        p.alignment = textElement.parent.alignment;
                        const elem = new TextElement(ViewModelText.getNewId(), value, p, textElement.required, true);
                        elem.control = textElement.control;
                        p.values = [elem];
                        textElement.parent.parent.paragraphs.splice(indexOfParent+1, 0, p);
                        textElement = p.values[0];
                    });
                }
            }

        }
    }



    openNameDialog(): void {
        const dialogRef = this.dialog.open(SaveViewDialogComponent, {
            width: '500px',
            data: {name: this.formGroup.get('name').value}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.formGroup.get('name').setValue(result);
                this.saveChanges();
            }
        });
    }

    saveChanges() {
        this.appService.setLoading(true);
        this.viewData.name = this.formGroup.get('name').value;
        const skipedData: FormViewFieldData[] = [];
        Object.keys(this.formGroup.controls).forEach(key => {
            const control: AbstractControl = this.formGroup.get(key);
            if (key !== 'name') {
                const fieldData = this.viewData.findFieldData(+key);
                if (control.enabled && (fieldData != null)) {
                    fieldData.value = control.value.replace(/&nbsp;/g, " ");
                } else if (control.enabled && (fieldData == null)) {
                    const newData: FormViewFieldData = new FormViewFieldData();
                    newData.value = control.value;
                    newData.field = new FormViewField();
                    newData.field.id = +key;
                    this.viewData.values.push(newData);
                } else if (control.disabled && (fieldData != null)) {
                    this.viewData.removeFieldData(fieldData.id);
                    skipedData.push(fieldData);
                }
            }
        });
        this.viewData.view.fields = []; // Para evitar el fallo en la conversión del JSON en el backend
        let stream: Observable<any>;
        if (skipedData.length > 0) {
            stream = this.viewService
                .deleteViewDataFields(skipedData)
                .switchMap(() => this.viewService.updateViewData(this.viewData));
        } else {
            stream = this.viewService.updateViewData(this.viewData);
        }
        stream
            .subscribe(view => {
                this.appService.setLoading(false);
                this.appService.sendMsg(MessageSeverity.SUCCESS, 'Éxito', 'Vista modelo modificada exitosamente');
                this.router.navigate(["home", "view", "filled"] );
            }, error => {
                this.appService.setLoading(false);
                this.appService.sendMsg(MessageSeverity.ERROR, 'Error', 'Se produjo un error al guardar');
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/data/form-view-data-editor/form-view-data-editor.component.ts